import api from "../httpClient"

export const safetySignals = {
  markViewed: async (id: number) => {
    const resp = await api.post(`/api/admin/safety-signals/${id}/mark-viewed/`)
    return resp.data
  },
  updateNote: async (id: number, adminNote: string) => {
    const resp = await api.patch(`/api/admin/safety-signals/${id}/update-note/`, {
      admin_note: adminNote,
    })
    return resp.data
  },
  notifyMentor: async (id: number) => {
    const resp = await api.post(`/api/admin/safety-signals/${id}/notify-mentor/`)
    return resp.data
  },
  resolve: async (id: number) => {
    const resp = await api.post(`/api/admin/safety-signals/${id}/resolve/`)
    return resp.data
  },
  dismiss: async (id: number) => {
    const resp = await api.post(`/api/admin/safety-signals/${id}/dismiss/`)
    return resp.data
  },
  clearCompletion: async (id: number) => {
    const resp = await api.post(`/api/admin/safety-signals/${id}/clear-completion/`)
    return resp.data
  },
}
